import { Layout as AlphaLayout } from '@oneaudi/unified-web-alpha-components';

export default AlphaLayout;
